<section class="!min-w-0 !overflow-visible !rounded-2xl !border !border-solid !border-border !bg-white !p-6 md:!p-8"
             aria-labelledby="company-docs-title">
        <div class="!mb-5 !border-b !border-solid !border-slate-100 !pb-3">
            <h3 id="company-docs-title" class="!mb-1 !text-base !font-bold !text-strong">Documentazione società</h3>
            <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                Regolamento interno e firma del rappresentante, usati nei moduli e nelle iscrizioni.
            </p>
        </div>

        <div class="!grid !grid-cols-1 !gap-x-5 !gap-y-5 md:!grid-cols-2">
            <div class="!min-w-0">
                <ui-file-field
                    inputId="settings-company-rules"
                    label="Regolamento societario"
                    icon="bi-file-earmark-text"
                    placeholder="Carica il regolamento"
                    hint="PDF, JPG o PNG. Usato nei moduli di iscrizione."
                    [fileUrl]="rulesUrl"
                    (fileChange)="rulesChange.emit($event)">
                </ui-file-field>
            </div>
            <div class="!min-w-0">
                <ui-file-field
                    inputId="settings-company-signature"
                    label="Firma rappresentante"
                    icon="bi-pen"
                    placeholder="Carica la firma"
                    hint="PDF, JPG o PNG. Firma usata sui documenti."
                    [fileUrl]="signatureUrl"
                    (fileChange)="signatureChange.emit($event)">
                </ui-file-field>
            </div>
            <div class="!min-w-0">
                <label class="form-label !mb-1.5 !block !text-sm !font-semibold !text-slate-600" for="settings-shipment-price">Prezzo spedizione</label>
                <input id="settings-shipment-price" type="number" step="0.01"
                       class="form-control !box-border !h-11 !min-h-11 !w-full !rounded-xl !border !border-solid !border-slate-200 !bg-white !px-3.5 !py-0 !text-base !text-slate-800 !shadow-none focus:!border-primary focus:!bg-white focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                       [(ngModel)]="company.shipmentPrice" name="settings-shipment-price"/>
            </div>
        </div>
    </section>

<section class="!min-w-0 !overflow-visible !rounded-2xl !border !border-solid !border-border !bg-white !p-6 md:!p-8"
             *ngIf="showShopPolicy" aria-labelledby="shop-policy-title">
        <div class="!mb-5 !border-b !border-solid !border-slate-100 !pb-3">
            <h3 id="shop-policy-title" class="!mb-1 !text-base !font-bold !text-strong">Shop e policy</h3>
            <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                Link e script per cookie e privacy dello shop.
            </p>
        </div>
        <div class="!grid !grid-cols-1 !gap-x-5 !gap-y-5 md:!grid-cols-2">
            <div class="!min-w-0">
                <label class="form-label !mb-1.5 !block !text-sm !font-semibold !text-slate-600" for="settings-cookie-policy">Cookie policy</label>
                <input id="settings-cookie-policy" type="text"
                       class="form-control !box-border !h-11 !min-h-11 !w-full !rounded-xl !border !border-solid !border-slate-200 !bg-white !px-3.5 !py-0 !text-base !text-slate-800 !shadow-none focus:!border-primary focus:!bg-white focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                       [(ngModel)]="company.cookiePolicyUrl" name="settings-cookie-policy"/>
            </div>
            <div class="!min-w-0">
                <label class="form-label !mb-1.5 !block !text-sm !font-semibold !text-slate-600" for="settings-privacy-policy">Privacy policy</label>
                <input id="settings-privacy-policy" type="text"
                       class="form-control !box-border !h-11 !min-h-11 !w-full !rounded-xl !border !border-solid !border-slate-200 !bg-white !px-3.5 !py-0 !text-base !text-slate-800 !shadow-none focus:!border-primary focus:!bg-white focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                       [(ngModel)]="company.privacyPolicyUrl" name="settings-privacy-policy"/>
            </div>
            <div class="!min-w-0 md:!col-span-2">
                <label class="form-label !mb-1.5 !block !text-sm !font-semibold !text-slate-600" for="settings-iubenda">Script Iubenda</label>
                <textarea id="settings-iubenda"
                          class="form-control !box-border !min-h-[6.5rem] !w-full !rounded-xl !border !border-solid !border-slate-200 !bg-white !px-3.5 !py-3 !text-base !text-slate-800 !shadow-none focus:!border-primary focus:!bg-white focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                          [(ngModel)]="company.iubendaScript" name="settings-iubenda"
                          placeholder="Inserisci lo script Iubenda per intero (<script>...</script>)"></textarea>
            </div>
        </div>
    </section>

<section class="!min-w-0 !overflow-visible !rounded-2xl !border !border-solid !border-border !bg-white !p-6 md:!p-8 lg:!col-span-2"
             *ngIf="hasGlobalVisibility" aria-labelledby="welldone-settings-title">
        <div class="!mb-5 !border-b !border-solid !border-slate-100 !pb-3">
            <h3 id="welldone-settings-title" class="!mb-1 !text-base !font-bold !text-strong">Impostazioni Well Done</h3>
            <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                Dominio, recapito notifiche e agente assegnato. Visibile solo con visibilità globale.
            </p>
        </div>
        <div class="!grid !grid-cols-1 !gap-x-5 !gap-y-5 md:!grid-cols-2">
            <div class="!min-w-0">
                <label class="form-label required !mb-1.5 !block !text-sm !font-semibold !text-slate-600" for="settings-domain">Dominio</label>
                <input id="settings-domain" type="text"
                       class="form-control !box-border !h-11 !min-h-11 !w-full !rounded-xl !border !border-solid !border-slate-200 !bg-white !px-3.5 !py-0 !text-base !text-slate-800 !shadow-none focus:!border-primary focus:!bg-white focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                       [(ngModel)]="company.domain" name="settings-domain"/>
            </div>
            <div class="!min-w-0">
                <label class="form-label !mb-1.5 !block !text-sm !font-semibold !text-slate-600" for="settings-shop-domain">Dominio shop</label>
                <input id="settings-shop-domain" type="text"
                       class="form-control !box-border !h-11 !min-h-11 !w-full !rounded-xl !border !border-solid !border-slate-200 !bg-white !px-3.5 !py-0 !text-base !text-slate-800 !shadow-none focus:!border-primary focus:!bg-white focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                       [(ngModel)]="company.shopDomain" name="settings-shop-domain"/>
            </div>
            <div class="!min-w-0">
                <label class="form-label !mb-1.5 !block !text-sm !font-semibold !text-slate-600" for="settings-receiving-email">Email notifiche</label>
                <input id="settings-receiving-email" type="email"
                       class="form-control !box-border !h-11 !min-h-11 !w-full !rounded-xl !border !border-solid !border-slate-200 !bg-white !px-3.5 !py-0 !text-base !text-slate-800 !shadow-none focus:!border-primary focus:!bg-white focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                       [(ngModel)]="company.receivingEmail" name="settings-receiving-email"/>
            </div>
            <div class="!min-w-0">
                <label class="form-label !mb-1.5 !block !text-sm !font-semibold !text-slate-600" for="settings-company-agent">Agente</label>
                <div class="!relative">
                    <select id="settings-company-agent"
                            class="form-control !box-border !h-11 !min-h-11 !w-full !appearance-none !rounded-xl !border !border-solid !border-slate-200 !bg-white !bg-none !px-3.5 !pr-10 !py-0 !text-base !text-slate-800 !shadow-none focus:!border-primary focus:!bg-white focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                            [(ngModel)]="company.agentId" name="settings-company-agent">
                        <option value="">Seleziona...</option>
                        <option *ngFor="let agent of agents" [value]="agent.id">
                            {{ agent.firstName }} {{ agent.lastName }} {{ agent.email }}
                        </option>
                    </select>
                    <i class="bi bi-chevron-down !pointer-events-none !absolute !right-3.5 !top-1/2 !-translate-y-1/2 !text-sm !text-slate-400" aria-hidden="true"></i>
                </div>
            </div>
        </div>

        <div *ngIf="isSuperAdmin" class="!mt-6 !border-t !border-solid !border-slate-100 !pt-5">
            <div class="!mb-4 !flex !flex-wrap !items-start !justify-between !gap-3">
                <div>
                    <h4 class="!mb-1 !text-sm !font-bold !text-strong">Record DNS Cloudflare</h4>
                    <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                        Crea il CNAME della società e dello shop (shop.nome) sul dominio Well Done.
                    </p>
                </div>
                <button type="button"
                        class="btn btn-primary"
                        (click)="createRecord()"
                        [disabled]="savingDomain">
                    <span *ngIf="savingDomain" class="spinner-border spinner-border-sm me-2" role="status"></span>
                    Crea record
                </button>
            </div>

            <p *ngIf="loadingDomains" class="!mb-0 !text-sm !text-subtle">Caricamento record...</p>
            <p *ngIf="!loadingDomains && domains.length === 0" class="!mb-0 !text-sm !text-subtle">
                Nessun record DNS associato a questa società.
            </p>
            <div *ngIf="!loadingDomains && domains.length > 0" class="!flex !flex-col !gap-2">
                <div *ngFor="let domain of domains"
                     class="!flex !flex-wrap !items-center !justify-between !gap-3 !rounded-xl !border !border-solid !border-slate-200 !bg-slate-50 !px-4 !py-3">
                    <div class="!min-w-0">
                        <div class="!font-semibold !text-slate-800">{{ domain.name }}</div>
                        <div class="!text-xs !text-slate-500">
                            {{ fieldLabel(domain.field) }}
                            <span *ngIf="domain.content"> · {{ domain.content }}</span>
                            <span *ngIf="!domain.recordId"> · non ancora su Cloudflare</span>
                        </div>
                    </div>
                    <button type="button"
                            class="btn welldone-btn-light"
                            (click)="deleteRecord(domain)">
                        Elimina
                    </button>
                </div>
            </div>
        </div>
</section>
